var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./baseService";
class EmployeePictureService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "employee_picture";
    }
    postEmployeePictures(id, pictures) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign({}, this.getDefaultHeaders()), { "Content-Type": "multipart/form-data" });
            const { data } = yield this.api.post(`/${this.controllerName}?employeeId=${id}`, pictures, { headers });
            return data;
        });
    }
}
export const employeePictureService = new EmployeePictureService();
//# sourceMappingURL=employeePictureService.js.map